import {
  Alignment,
  Button,
  Classes,
  Collapse,
  FormGroup,
  H5,
  InputGroup,
  Popover,
  Position,
  Tooltip,
} from "@blueprintjs/core";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { IEmpresa, IIcmsClassificacao, newEmpresa } from "../../../model";
import { AppStore } from "../../../stores/AppStore";
import { LookupStore } from "../../../stores/LookupStore";
import { ResultadoStore } from "../../../stores/resultados/ResultadoStore";
import { PagerResultados } from "../../utils/PagerResultados";
import { IcmsClassificacaoSelect, filterIcmsClassificacao, renderIcmsClassificacao } from "../../utils/IcmsClassificacaoSelect";
import DetalhamentoNfseTable from "./detalhamento_nfse_table";

var debounce = require('lodash.debounce');

interface Props {
  handleContestarLote: () => void;
}

interface State {
  handleContestarLote: () => void;
}

@observer
export default class DetalhamentoNfse extends React.Component<Props, State> {

  obs = observable({
    selectedTab: "summary" as string,
    tipo: "Entrada" as string,
    modeloQuery: "" as string,
    razao_social_empresa: "" as string,
    selectedEmpresa: newEmpresa() as IEmpresa,
    selectedPeriod: [] as any,
    fetchOptions: {} as any,
    filtrosAbertos: true as boolean
  })

  constructor(props) {
    super(props);
    ResultadoStore.obs.results = [];
    ResultadoStore.obs.summary = [];

    this.state = {
      handleContestarLote: props.handleContestarLote,
    };

    this.obs.fetchOptions = debounce(this.handleQuery.bind(this), 800);

  }

  async handleQuery() {

    await ResultadoStore.query();

  }

  handleContestarTodos() {
    ResultadoStore.selectAllContestarLoteCTE();
    ResultadoStore.obs.contestar_todos = true;
    this.state.handleContestarLote();
  }

  handleBuscaDetalhamento(e) {

    if (e.target.value === "") {
      ResultadoStore.resetContestarItems();
    }

    ResultadoStore.obs.current_page = 1
  }

  async handlePageChange(pager) {

    ResultadoStore.obs.current_page = pager

    this.handleQuery()

  }

  async handleChangeClass(item) {

    ResultadoStore.setIcmsClassFilter(item);

    ResultadoStore.obs.current_page = 1

    this.handleQuery()

  }

  async handleQueryFilters(e) {

    ResultadoStore.obs.current_page = 1

    this.obs.fetchOptions()

  }

  render() {
    let results_nfse = ResultadoStore.obs.results;

    let selectedItemCaption = ResultadoStore.selectedCount == 1 ? "item" : "itens";
    let niveis_acesso = AppStore.obs1.usuario ? AppStore.obs1.usuario.niveis_acesso : [""];

    let classItems = LookupStore.obs.icms_classificacoes.concat(
      [
        {
          codigo_receita: "0000",
          nome: "Sem classificação (itens não calculados)",
        },
      ],
      [{ codigo_receita: "00000", nome: "Todas" }]
    );

    return (
      <>
        <MDBCol>
          <MDBRow>

            <MDBCol>
              <MDBRow>
                <FormGroup label="Filtro de Classificação" style={{ width: "60%" }}>
                  <IcmsClassificacaoSelect
                    items={classItems}
                    itemRenderer={renderIcmsClassificacao}
                    itemPredicate={filterIcmsClassificacao}
                    onItemSelect={(item: IIcmsClassificacao) => this.handleChangeClass(item)}
                  >
                    <Button
                      text={
                        (ResultadoStore.obs.icmsClassFilter &&
                          ResultadoStore.obs.icmsClassFilter.nome) ||
                        "Selecionar classificação..."
                      }
                      rightIcon="double-caret-vertical"
                      alignText={Alignment.LEFT}
                      className="IcmsClassificacao"
                    />
                  </IcmsClassificacaoSelect>
                </FormGroup>

                &nbsp;

                {AppStore.obs1.usuario &&
                  <div style={{ width: "30%", paddingTop: 27 }}>
                    <Tooltip
                      content={`Contestar ${ResultadoStore.obs.contestar_todos ? "todos" : ResultadoStore.selectedCount} ${selectedItemCaption}`}
                      disabled={ResultadoStore.selectedCount == 0}
                    >
                      <Button 
                        className="btncontestarWidth" 
                        disabled={ResultadoStore.selectedCount == 0 || niveis_acesso.indexOf("c2") == -1}
                        icon="issue"
                        onClick={this.state.handleContestarLote}
                      >
                        Contestar Selecionados
                      </Button>
                    </Tooltip>
                  </div>
                }
              </MDBRow>
            </MDBCol>

            <MDBCol>
              <MDBRow style={{ float: "right" }}>
                <div style={{ paddingTop: 27 }}>
                  <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING} position={Position.LEFT_BOTTOM}>
                    <MDBBtn className="btnDefault btnBuscarNfe" disabled={niveis_acesso.indexOf("c2") == -1}>Selecionar Todos</MDBBtn>
                    <div>
                      <H5>Confirmar Seleção</H5>
                      <p>Tem certeza que deseja selecionar todos os itens?</p>
                      <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 15 }}>
                        <Button className={Classes.POPOVER_DISMISS} style={{ marginRight: 10 }} onClick={() => ResultadoStore.resetContestarItems()}>Não</Button>
                        <Button intent="danger" className={Classes.POPOVER_DISMISS} onClick={() => this.handleContestarTodos()}>Sim</Button>
                      </div>
                    </div>
                  </Popover>
                </div>
              </MDBRow>
            </MDBCol>

          </MDBRow>
        </MDBCol>

        <div className="detalhamento-filtros">
          <div className="detalhamento-filtros-header" onClick={() => this.obs.filtrosAbertos = !this.obs.filtrosAbertos}>
            <span className="detalhamento-filtros-title">
              Filtros
              {Object.values(ResultadoStore.obs.filters).filter((v: string) => v?.trim()).length > 0 && (
                <span className="detalhamento-filtros-badge">
                  {Object.values(ResultadoStore.obs.filters).filter((v: string) => v?.trim()).length}
                </span>
              )}
            </span>
            <span className={`detalhamento-filtros-toggle ${this.obs.filtrosAbertos ? "open" : ""}`}>
              {this.obs.filtrosAbertos ? "keyboard_arrow_up" : "keyboard_arrow_down"}
            </span>
          </div>
          <Collapse isOpen={this.obs.filtrosAbertos}>
            <div className="detalhamento-filtros-grid" style={{ paddingTop: 14 }}>
              <FormGroup label="Número da Nota" style={{ marginBottom: 0 }}>
                <InputGroup placeholder="Filtrar Número da Nota" value={ResultadoStore.obs.filters.filterNumero} onChange={(e) => this.handleQueryFilters(ResultadoStore.obs.filters.filterNumero = e.target.value)} />
              </FormGroup>

              <FormGroup label="Descrição" className="filtro-lg" style={{ marginBottom: 0 }}>
                <InputGroup placeholder="Filtrar descrição" value={ResultadoStore.obs.filters.filterDescricao} onChange={(e) => this.handleQueryFilters(ResultadoStore.obs.filters.filterDescricao = e.target.value)} />
              </FormGroup>

              <FormGroup label="Chave" className="filtro-lg" style={{ marginBottom: 0 }}>
                <InputGroup placeholder="Filtrar Chave" value={ResultadoStore.obs.filters.filterChave} onChange={(e) => this.handleQueryFilters(ResultadoStore.obs.filters.filterChave = e.target.value)} />
              </FormGroup>
            </div>
          </Collapse>
        </div>

        <DetalhamentoNfseTable
          modelo={ResultadoStore.obs.modelo}
          items={results_nfse}
          data={this.obs.selectedPeriod}
          entrada_saida={ResultadoStore.obs.tipo}
        />

        <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
          <PagerResultados
            currentPage={ResultadoStore.obs.current_page}
            totalCount={ResultadoStore.obs.itemsCount}
            onPageChange={page => this.handlePageChange(page)}
            pageSize={15}
          />
        </div>

      </>
    );
  }
}
